import { render, staticRenderFns } from "./enroutedelay.vue?vue&type=template&id=640fe040&scoped=true"
import script from "./enroutedelay.vue?vue&type=script&lang=js"
export * from "./enroutedelay.vue?vue&type=script&lang=js"
import style0 from "./enroutedelay.vue?vue&type=style&index=0&id=640fe040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640fe040",
  null
  
)

export default component.exports